/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCommissionStatementDtoFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeCommissionStatementDto, serializeMarkPaidRequest, type CommissionStatementDto, type ErrorResponse, type InternalErrorResponse, type MarkPaidRequest } from '../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/commissions/statements/{commissionStatementId}/mark-paid
 */
export interface MarkPaidRequestBuilder extends BaseRequestBuilder<MarkPaidRequestBuilder> {
    /**
     * Records that the rep has been paid and closes the statement. Paid is terminal: nothing moves a statement out of it, so it can no longer be disputed or returned to review, and this is the one step in the workflow that cannot be walked back. Only an Approved statement can be marked paid — a disputed one must be returned to review and approved first. This endpoint records the payment rather than making it; no money moves and no billing system is contacted. `paymentReference` is optional, and where supplied is kept on the statement and written into its history — send the cheque or transfer number so the payment can be traced later.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CommissionStatementDto>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: MarkPaidRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CommissionStatementDto | undefined>;
    /**
     * Records that the rep has been paid and closes the statement. Paid is terminal: nothing moves a statement out of it, so it can no longer be disputed or returned to review, and this is the one step in the workflow that cannot be walked back. Only an Approved statement can be marked paid — a disputed one must be returned to review and approved first. This endpoint records the payment rather than making it; no money moves and no billing system is contacted. `paymentReference` is optional, and where supplied is kept on the statement and written into its history — send the cheque or transfer number so the payment can be traced later.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: MarkPaidRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const MarkPaidRequestBuilderUriTemplate = "{+baseurl}/api/commissions/statements/{commissionStatementId}/mark-paid";
/**
 * Metadata for all the requests in the request builder.
 */
export const MarkPaidRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: MarkPaidRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCommissionStatementDtoFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeMarkPaidRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
